module.exports = __webpack_public_path__ + "img/chambers.6fb2adf3.svg";